export default "__VITE_ASSET__DjsmrGFm__"